import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'components';
import { connect } from 'react-redux';
import { create as createForm, clearForm } from 'redux/modules/forms';
var FormProvider = (_dec = connect(function (state, _ref) {
  var name = _ref.name;
  return {
    isInstantiated: state.forms && state.forms[name]
  };
}, {
  createForm: createForm,
  clearForm: clearForm
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FormProvider, _Component);

  var _super = _createSuper(FormProvider);

  function FormProvider() {
    _classCallCheck(this, FormProvider);

    return _super.apply(this, arguments);
  }

  _createClass(FormProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          name = _this$props.name,
          defaultState = _this$props.defaultState,
          createForm = _this$props.createForm,
          isInstantiated = _this$props.isInstantiated;

      if (!isInstantiated) {
        createForm(name, defaultState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.clearOnUnmount) {
        this.props.clearForm(this.props.name);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isInstantiated = _this$props2.isInstantiated,
          loading = _this$props2.loading,
          children = _this$props2.children;

      if (isInstantiated) {
        return children;
      }

      return loading || /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });
    }
  }]);

  return FormProvider;
}(Component), _defineProperty(_class2, "defaultProps", {
  clearOnUnmount: true
}), _temp)) || _class);
export default FormProvider;